import React, { Component } from 'react';
import {observer} from 'mobx-react';
import styles from './index.css';
import {FinanceData} from '../../components/index';
import {time, score, storageStore, finance} from '../../stores/index';
import {Link} from 'react-router-dom';
import GameResults from "../../components/Results";
import fonts from '../../../iconfonts.css';
import {cropPlan, presets, receptionBunkersStore} from "../../stores";

@observer
export default class Results extends Component{
    componentDidMount(){
        time.breaker();
        storageStore.silosList.forEach((item)=>{
            if(item.amount > 0 && item.culture !== "None"){
                finance.incParams('output',item.culture,item.amount);
            }
        });
        storageStore.hoppersList.forEach((item)=>{
            if(item.amount > 0 && item.culture !== "None"){
                finance.incParams('output',item.culture,item.amount);
            }
        })
    }

    sum(element='') {
        return Object.keys(finance).reduce((previousValue, currentValue) => {
            let newData = finance[currentValue];
            return previousValue + Object.keys(finance[currentValue]).reduce((previousValue, currentValue) => {
                if(currentValue !== 'elem' && currentValue !== 'total'){
                    return previousValue + newData[currentValue][element];
                }
                return previousValue;
            },0);
        },0);
    }
    render(){
        let total = 0;
        let arr = ["wheat", "rape", "soy", "sunflower", "corn"]
        arr.forEach(item=>{
            total += Object.keys(finance).reduce((previousValue, currentValue) => {
                return previousValue + finance[currentValue].total[item]},0);
        });
        return(
            <div style={{display:"flex",flexDirection:"column",alignItems:"center", margin:"1rem 0 2rem"}}>
                <h1 >Кінець сесії!</h1>
                <div className={styles.elevatorsScoreSettings}>
                        <div className={styles.column}>
                            <h2>Вартість елеватора: {score.total}$</h2>
                            <h2>EBITDA:  {
                                ((this.sum('cashYield') - this.sum('directExpends') - this.sum('indirectExpends'))).toFixed(2)
                            } $</h2>
                            <h2>EBITDA ($/т):  {
                                ((this.sum('cashYield') - this.sum('directExpends') - this.sum('indirectExpends'))/((cropPlan.totalWeight['wheat'] +
                                    cropPlan.totalWeight['rape'] +
                                    cropPlan.totalWeight['soy'] +
                                    cropPlan.totalWeight['sunflower'] +
                                    cropPlan.totalWeight['corn']) -
                                    (cropPlan.currentWeight['wheat'] +
                                        cropPlan.currentWeight['rape'] +
                                        cropPlan.currentWeight['soy'] +
                                        cropPlan.currentWeight['sunflower'] +
                                        cropPlan.currentWeight['corn']))).toFixed(2)
                            } $/т
                            </h2>
                            <h2>Roce ($/т): {((this.sum('cashYield') - this.sum('directExpends')- this.sum('indirectExpends'))/score.total*100).toFixed(2)} %</h2>
                        </div>
                        <div className={styles.column}>
                            <h2>Загальний обсяг приймання: {
                                ((cropPlan.totalWeight['wheat'] +
                                    cropPlan.totalWeight['rape'] +
                                    cropPlan.totalWeight['soy'] +
                                    cropPlan.totalWeight['sunflower'] +
                                    cropPlan.totalWeight['corn']) -
                                (cropPlan.currentWeight['wheat'] +
                                    cropPlan.currentWeight['rape'] +
                                    cropPlan.currentWeight['soy'] +
                                    cropPlan.currentWeight['sunflower'] +
                                    cropPlan.currentWeight['corn'])).toFixed(1)
                            } т.
                            </h2>
                            <h2>Кількість обертів: {
                                (((cropPlan.totalWeight['wheat'] +
                                    cropPlan.totalWeight['rape'] +
                                    cropPlan.totalWeight['soy'] +
                                    cropPlan.totalWeight['sunflower'] +
                                    cropPlan.totalWeight['corn']) -
                                (cropPlan.currentWeight['wheat'] +
                                    cropPlan.currentWeight['rape'] +
                                    cropPlan.currentWeight['soy'] +
                                    cropPlan.currentWeight['sunflower'] +
                                    cropPlan.currentWeight['corn']))/
                                    storageStore.silosList.reduce((prev,curr)=>{return prev+curr.totalCapacity},0)).toFixed(1)
                            }
                            </h2>
                            <div><h2>Прийнято:</h2></div>
                            <div style={{width: "35rem"}}>
                                <div className={styles.cropPlanCultures}>
                                    <CultureStats culture="wheat" title="Пшениця" />
                                    <CultureStats culture="rape" title="Ріпак"/>
                                    <CultureStats culture="soy" title="Соя"/>
                                    <CultureStats culture="sunflower" title="Соняшник"/>
                                    <CultureStats culture="corn" title="Кукурудза"/>
                                </div>
                            </div>
                        </div>
                    <GameResults/>
                </div>
                <FinanceData />
                <Link to="/" className={styles.menuButton + ' ' + styles.active}>Вийти</Link>
            </div>
        )
    }

}

@observer
class CultureStats extends Component{
    render() {
        return (
            <div className={styles.cropPlanCulture}>
                <div className={styles.cultureCircle + ' ' + styles[this.props.culture]}><i className={fonts[this.props.culture]}/>
                </div>
                <h4>{this.props.title}</h4>
                <p>{Math.floor(cropPlan.totalWeight[this.props.culture]) -Math.floor(cropPlan.currentWeight[this.props.culture])} т.</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/containers/Results/index.js